export enum ECustomEventsDescriptions {
  onSubmit = 'Данные из микрофронта калькулятора OfferCalculator',
  onError = 'Ошибки из микрофронта калькулятора OfferCalculator',
  onAnalytics = 'Аналитика из микрофронта калькулятора OfferCalculator',
  onReset = 'Сброс фильтров калькулятора OfferCalculator к начальным значениям',
}
